<template>
  <div>
    <wg-modal
      :width="windowWidth > 700 ? '700px' : '90%'"
      v-if="showWcDialog"
      @closeModal="showWcDialog = !showWcDialog"
    >
    <div class="com-anm22-app-text-l" slot="header">
      {{ $anm22.strLang(lang, 'Edit work cost', 'Modifica categoria di costo') }}
    </div>
    <div class="wg-row" slot="body">
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Name', 'Nome') }}</div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
            type="text"
            v-model="wcSelected.name"
          >
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Area', 'Area') }}</div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <select class="com-anm22-app-select" v-model="wcSelected.area">
            <option disabled value>{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
            <option 
                v-for="(wca,key,index) in $anm22.tableClasses.worldWorkCostArea().getAll()"
                :key="'wca-'+index"
                :value="key">
              {{ wca[lang] }}
            </option>
          </select>
        </div>
      </div>
      <div style="height: 15px" class="vertical-height-div"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Weekday price ', 'Costo giorno feriale ') + '(EUR)' }}</div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.weekDayPrice"
          >
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Holiday price ', 'Costo giorno festivo ') + '(EUR)' }}</div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.holidayPrice"
          >
        </div>
      </div>
      <div style="height: 15px" class="vertical-height-div"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Night price ', 'Costo notturna ') + '(EUR)' }}</div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.nightPrice"
          >
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row" style="align-items:center;">
            <div class="com-anm22-app-text-m">
              {{ 
                $anm22.strLang(lang, 'Workday of less than ', 'Costo giornata con meno di ') 
              }}
            </div>
            <input
              class="com-anm22-app-input-text"
              style="width:50px;margin:0 5px;"
              type="number"
              v-model="wcSelected.hoursCap"
            >
            <div class="com-anm22-app-text-m">
              {{ 
                $anm22.strLang(lang, 'hours of work ', 'ore di lavoro ') + '(EUR)' 
              }}
            </div>
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.dayWithLessThanCapHoursPrice"
          >
        </div>
      </div>
      <div style="height: 15px" class="vertical-height-div"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Included hours', 'Ore comprese') }}</div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.includedHours"
          >
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, 
              'Price per not included hours (Weekday)(EUR/h)', 
              'Costo ore non incluse (Giorni feriali) (EUR/h)'
            ) }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.pricePerNotIncludedHoursWeekday"
          >
        </div>
      </div>
      <div style="height: 15px" class="vertical-height-div"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, 
              'Price per not included hours (Holiday)(EUR/h)', 
              'Costo ore non incluse (Giorni festivi) (EUR/h)'
            ) }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.pricePerNotIncludedHoursHoliday"
          >
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, 
              'Price per not included hours (Night)(EUR/h)', 
              'Costo ore non incluse (Notturna) (EUR/h)'
            ) }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.pricePerNotIncludedHoursNight"
          >
        </div>
      </div>
      <div style="height: 15px" class="vertical-height-div"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, 
              'Daily Allowance (EUR/day)', 
              'Diaria (EUR/gg)'
            ) }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            type="number"
            v-model="wcSelected.dailyPay"
          >
        </div>
      </div>
      <div style="height: 20px" class="vertical-height-div"></div>
      <div class="wg-col wg-xs-12">
        <input
            type="button" 
            :value="$anm22.strLang(lang, 'Save', 'Salva')"
            @click="saveWorkCost"
        >
      </div>
    </div>
    </wg-modal>
    <template v-if="hasAccess && contact.workOwner == 474">
      <h1 class="com-anm22-page-title">
        {{ pricing
        ? $anm22.strLang(lang, 'Edit pricing', 'Modifica condizioni economiche')
        : $anm22.strLang(lang, 'New pricing', 'Crea condizioni economiche') }}
      </h1>
      <template v-if="!loading">
        <template v-if="pricing">
          <!-- Gestione categorie di costo -->
          <div
            class="com-anm22-app-text-xl"
          >{{ $anm22.strLang(lang, 'Cost categories', 'Categorie di costo') }}</div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div
            v-if="costCategories.length === 0"
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'No cost categories', 'Nessuna categoria di costo') }}</div>
          <template v-else>
            <div
              v-for="(wc, index) in costCategories"
              :key="'wc'+index"
              class="wg-row"
              style="margin:5px 0;font-size:14px;align-items:center;"
            >
              <div class="display-flex" style="align-items:center;">
                <div class="com-anm22-app-text-m">{{ wc.name }}</div>
                <img
                  v-if="!onlyView"
                  class="com-anm22-app-img-xs"
                  style="margin-left:3px;cursor:pointer;"
                  :src="$anm22.icons.getWorldIcon('edit')"
                  :title="$anm22.strLang(lang, 'Edit', 'Modifica categoria di costo')"
                  @click="editWorkCost(wc)"
                >
              </div>
            </div>
          </template>
          <template v-if="!onlyView">
            <div class="vertical-height-div" style="height:10px;"></div>
            <!-- Aggiunta di una categoria di costo -->
            <div class="wg-row">
              <input 
                type="button" 
                class="small"
                :value="$anm22.strLang(lang, '+ Add', '+ Aggiungi')"
                @click="newWorkCost">
            </div>
          </template>
          <div class="vertical-height-div" style="height:15px;"></div>
          <!-- Gestione tipologie di spesa -->
          <div
            class="com-anm22-app-text-xl"
          >{{ $anm22.strLang(lang, 'Expense types', 'Tipologie di spesa') }}</div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div
            v-if="outgoCategories.length === 0"
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'No outgo categories', 'Nessuna tipologia di spesa') }}</div>
          <template v-else>
            <div
              v-for="(oc, index) in outgoCategories"
              :key="'oc'+index"
              class="wg-row"
              style="margin:5px 0;font-size:14px;height:20px;align-items:center;"
            >
              <!-- category image to-do -->
              <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
              <div
                :class="['work-pricing-category-diary', oc.selected ? 'selected' : '']"
                @click="toggleOutgoCategory(oc)"
              >✓</div>
              <template v-if="oc.selected">
                <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
                <div
                  :class="['work-pricing-category-diary', oc.diary ? 'selected' : '']"
                  @click="toggleOutgoCategoryDiary(oc)"
                >D</div>
              </template>
              <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
              <div
                class="com-anm22-app-text-m"
                :style="oc.deleted ? 'color:#b71c1c' : ''"
                :title="oc.deleted ? $anm22.strLang(lang, 'Type deleted', 'Tipologia cancellata') : ''"
              >{{ oc.name }}</div>
            </div>
          </template>
          <!-- Gestione pricing -->
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-xl"
            >{{ $anm22.strLang(lang, 'Night time', 'Orario notturno') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div class="wg-col wg-xs-3" style="padding:0 5px 0 0;">
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Start hours', 'Ore inizio') }}</div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <input
                :disabled="onlyView"
                class="com-anm22-app-input-number"
                :placeholder="$anm22.strLang(lang, 'Hours', 'Ore')"
                type="number"
                min="0"
                max="23"
                step="1"
                v-model.number="pricing.nightTimeStartHours"
              >
            </div>
            <div class="wg-col wg-xs-3" style="padding:0 5px 0 0;">
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Start minutes', 'Minuti inizio') }}</div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <input
                :disabled="onlyView"
                class="com-anm22-app-input-number"
                :placeholder="$anm22.strLang(lang, 'Minutes', 'Minuti')"
                type="number"
                min="0"
                max="59"
                step="1"
                v-model.number="pricing.nightTimeStartMinutes"
              >
            </div>
            <div class="wg-col wg-xs-3" style="padding:0 5px 0 0;">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'End hours', 'Ore fine') }}</div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <input
                :disabled="onlyView"
                class="com-anm22-app-input-number"
                :placeholder="$anm22.strLang(lang, 'Hours', 'Ore')"
                type="number"
                min="0"
                max="23"
                step="1"
                v-model.number="pricing.nightTimeEndHours"
              >
            </div>
            <div class="wg-col wg-xs-3" style="padding:0 5px 0 0;">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'End minutes', 'Ore fine') }}</div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <input
                :disabled="onlyView"
                class="com-anm22-app-input-number"
                :placeholder="$anm22.strLang(lang, 'Minutes', 'Minuti')"
                type="number"
                min="0"
                max="59"
                step="1"
                v-model.number="pricing.nightTimeEndMinutes"
              >
            </div>
          </div>
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Holiday calendar', 'Calendario festivi') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <select :disabled="onlyView" class="com-anm22-app-select" v-model="pricing.holidayCountry">
              <option disabled value>{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
              <!-- Set ristretto di paesi da poter scegliere -->
              <option value="it">{{ $anm22.tableClasses.worldCountry().getById('it')[lang] }}</option>
              <option value="sm">{{ $anm22.tableClasses.worldCountry().getById('sm')[lang] }}</option>
            </select>
          </div>
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Cost per kilometer (EUR/km)', 'Costo chilometrico (EUR/km)') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <input
              :disabled="onlyView"
              class="com-anm22-app-input-text"
              type="number"
              step="0.01"
              min="0"
              v-model="costPerKm"
            >
          </div>
          <div class="vertical-height-div" style="height:20px;"></div>
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Payment mode', 'Modalità di pagamento') }}</div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'Type', 'Tipologia') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <select :disabled="onlyView" class="com-anm22-app-select" v-model="pricing.paymentModeType">
              <option disabled value="0">{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
              <option
                v-for="(pm, key, index) in $anm22.tableClasses.worldPaymentModeType().getAll()"
                :key="'pm'+index"
                :value="key"
              >{{ pm[lang] }}</option>
            </select>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Support bank', 'Banca d\'appoggio') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <select :disabled="onlyView" class="com-anm22-app-select" v-model="pricing.paymentModeSupportBank">
              <option disabled value="">{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
              <option
                v-for="(baString, key, index) in bankAccountStrings"
                :key="'bas'+index"
                :value="baString"
              >{{ baString }}</option>
            </select>
          </div>
           <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Division of services and invoiced expenses', 'Divisione servizi e spese in fattura') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <select :disabled="onlyView" class="com-anm22-app-select" v-model="pricing.servicesAndExpensesDivision">
              <option value="1">{{ $anm22.strLang(lang, 'Yes', 'Si') }}</option>
              <option value="0">{{ $anm22.strLang(lang, 'No', 'No') }}</option>
            </select>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Service deferment', 'Dilazione servizi') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <select :disabled="onlyView" class="com-anm22-app-select" v-model="pricing.paymentModeServiceDeferment">
              <option disabled value="0">{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
              <option
                v-for="(def, key, index) in $anm22.tableClasses.deferment().getAll()"
                :key="'def'+index"
                :value="key"
              >{{ def[lang] }}</option>
            </select>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Outgoes deferment', 'Dilazione spese') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <select :disabled="onlyView" class="com-anm22-app-select" v-model="pricing.paymentModeOutgoesDeferment">
              <option disabled value="0">{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
              <option
                v-for="(def, key, index) in $anm22.tableClasses.deferment().getAll()"
                :key="'def'+index"
                :value="key"
              >{{ def[lang] }}</option>
            </select>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Advance bills deferment', 'Dilazione fatture di anticipo') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <select :disabled="onlyView" class="com-anm22-app-select" v-model="pricing.paymentModeBillsInAdvanceDeferment">
              <option disabled value="0">{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
              <option
                v-for="(def, key, index) in $anm22.tableClasses.deferment().getAll()"
                :key="'def'+index"
                :value="key"
              >{{ def[lang] }}</option>
            </select>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Website for currency change', 'Sito di riferimento per cambi di valuta') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <input
              :disabled="onlyView"
              class="com-anm22-app-input-text"
              :placeholder="'Url'"
              type="text"
              v-model="pricing.currencyChangeWebsite"
            >
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Surcharge for cash expenses (%)', 'Maggiorazione per spese in contanti (%)') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <input
              :disabled="onlyView"
              class="com-anm22-app-input-text"
              :placeholder="$anm22.strLang(lang, 'Surcharge', 'Maggiorazione')"
              type="number"
              min="0"
              v-model="pricing.increaseForCashOutgoes"
            >
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Supplier accountable', 'Responsabile presso il fornitore') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div v-if="!onlyView" class="wg-row" style="margin-bottom:10px;">
            <wg-search
              :placeholder="$anm22.strLang(lang, 'Supplier accountable', 'Responsabile presso il fornitore')"
              :url="'user/getByNameWithWork'"
              :clickFn="addCustomerManager"
              :attachedData="{work: contact.workOwner}"
              :debounceTime="2000"
            ></wg-search>
          </div>
          <template v-if="customerManagers.length">
            <div v-for="(cm, i) in customerManagers" :key="'cm-'+i" class="wg-row" style="align-items:center;">
              <img
                :src="$anm22.getObjIcon(cm, 'userDefault')"
                :title="cm.name"
                class="com-anm22-app-img-fixed-height-l com-anm22-round"
                style="margin-right:5px;"
              >
              <div>
                <div
                  class="com-anm22-app-text-m"
                  style="font-weight:bold;"
                >{{ cm.name + ' ' + cm.surname }}</div>
                <div class="vertical-height-div" style="height:2px;"></div>
                <div
                  v-if="!onlyView"
                  class="display-flex"
                  style="align-items:center;cursor:pointer;"
                  @click="removeCustomerManager(cm.idWorldUser)"
                >
                  <img class="com-anm22-app-img-fixed-height-s" :src="$anm22.icons.getWorldIcon('deleteRed')">
                  <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
                  <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Remove', 'Rimuovi') }}</div>
                </div>
              </div>
            </div>
          </template>
          <div
            v-else
            class="com-anm22-app-text-m"
          >{{ $anm22.strLang(lang, 'No employee selected', 'Nessun dipendente selezionato') }}</div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Order confirmation email', 'Email per conferme d\'ordine') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <input
              :disabled="onlyView"
              class="com-anm22-app-input-text"
              :placeholder="$anm22.strLang(lang, 'Order confirmation email', 'Email per conferme d\'ordine')"
              type="text"
              v-model="pricing.orderConfirmationSendingEmail"
            >
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Invoice sending email', 'Email per invio fatture') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <input
              :disabled="onlyView"
              class="com-anm22-app-input-text"
              :placeholder="$anm22.strLang(lang, 'Invoice sending email', 'Email per invio fatture')"
              type="text"
              v-model="pricing.invoiceSendingEmail"
            >
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Preliminary invoice sending email', 'Email per invio prefatture') }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <input
              :disabled="onlyView"
              class="com-anm22-app-input-text"
              :placeholder="$anm22.strLang(lang, 'Invoice sending email', 'Email per invio fatture')"
              type="text"
              v-model="pricing.preliminaryInvoiceSendingEmail"
            >
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div v-if="!onlyView" class="wg-row">
            <input type="button" :value="$anm22.strLang(lang, 'Save', 'Salva')" @click="savePricing">
          </div>
        </template>
        <template v-else-if="!onlyView">
            <div class="wg-row">
              <input
                type="button"
                :value="$anm22.strLang(lang, 'New pricing', 'Nuove condizioni')"
                @click="createNewPricing"
              >
            </div>
        </template>
      </template>
    </template>
    <div v-else class="wg-row">
      <div
        class="com-anm22-app-text-m"
      >{{ $anm22.strLang(lang, 'Permission denied.', 'Non hai i permessi per accedere a questa tab.') }}</div>
    </div>
    <div class="vertical-height-div" style="height:47px;"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    contactId: [Number, String],
    userPermission: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      // Aggiunta/modifica work cost
      showWcDialog: false,
      wcSelected: null
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      offline: state => state.offline.isOffline,
      windowWidth: state => state.windowWidth
    }),
    contact() {
      return this.$store.getters["contacts/get"](
        this.contactId
      );
    },
    pricing() {
      return this.$store.getters["pricings/getByContact"](
        this.contact.idContactsContact
      );
    },/* Recupero il responsabile di progetto, se c'è */
    customerManagers() {
      if(this.contact.managers) {
        return this.contact.managers.map(m => this.$store.getters['users/get'](m));
      } else {
        return [];
      }
    },
    hasAccess() {
      return this.userPermission <= 3 
        || ( this.userPermission > 3 
          && !!this.customerManagers.find(u => u.idWorldUser === this.user.idWorldUser)
        );
    },
    onlyView() {
      // Se è solo responsabile di progetto, con permessi bassi, può solo vedere le condizioni economiche
      return (
        this.userPermission > 3 &&
        !!this.customerManagers.find(u => u.idWorldUser === this.user.idWorldUser)
      );
    },
    costCategories() {
      return this.$store.getters["workCosts/getByContact"](
        this.contact.idContactsContact
      ).filter(wc => !wc.project);
    },
    outgoCategories() {
      if (!this.loading) {
        return this.$store.getters["outgoCategories/getBySupplier"](
          this.pricing.supplier
        ).map(oc => {
          const assoc = this.$store.getters["outgoCategoryContactAssocs/get"](
            oc.idWorldOutgoCategory + "-" + this.contact.idContactsContact,
          );
          if (assoc) {
            return {
              ...oc,
              selected: true,
              diary: assoc.diary,
              deleted: assoc.deleted
            };
          } else {
            return { ...oc, selected: false, diary: null, deleted: false };
          }
        });
      } else {
        return [];
      }
    },
    costPerKm: {
      get() {
        return this.pricing.costPerKm ? this.pricing.costPerKm.toFixed(2) : 0;
      },
      set(val) {
        this.pricing.costPerKm = val;
      }
    },
    bankAccountStrings() {
      return this.$store.getters['workBankAccountAssocs/getByWork'](this.contact.workOwner)
        .map(wba => {
          const ba = this.$store.getters['bankAccounts/get'](wba.bankAccount);
          return ba.owner +' - '+ (ba.iban || '') +' - '+ ba.bank;
        });
    }
  },
  methods: {
    showMessage() {
      this.$anm22.eventBus.$emit("world-headbar-show-message", {
        text: this.$anm22.strLang(
          this.lang,
          "Updated economic conditions",
          "Condizioni economiche aggiornate"
        ),
        type: "suggestion"
      });
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    savePricing() {
      if (!this.onlyView) {
        this.$http
          .post("link/pricing", {
            contactId: this.contact.idContactsContact,
            pricing: this.pricing
          }, {
            withCredentials: true
          })
          .then(response => {
            this.$store.dispatch("pricings/update", {
              vlf: this.$vlf("pricings"),
              objs: [response.data.pricing]
            });
          }).then(() => {
              this.showMessage();
          })
          .catch(error => {});
      }
    },
    editWorkCost(wc) {
      this.wcSelected = wc;
      this.showWcDialog = true;
    },
    newWorkCost(wc) {
      this.wcSelected = {};
      this.showWcDialog = true;
    },
    saveWorkCost() {
      this.$http
        .post('link/saveWorkCost', {
          contactId: this.contact.idContactsContact,
          workCost: this.wcSelected
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store.dispatch("workCosts/update", {
            vlf: this.$vlf("workCosts"),
            objs: [response.data.workCost]
          })
          .then(() => {
            this.wcSelected = null;
            this.showWcDialog = false;
          })
        })
        .catch(e => console.log(e));
    },
    toggleOutgoCategory(oc) {
      this.$http
        .post("link/toggleOutgoCategory", {
          contactId: this.contact.idContactsContact,
          categoryId: oc.idWorldOutgoCategory
        }, {
          withCredentials: true
        })
        .then(response => {
          //Selezione o deselezione
          if (oc.selected) {
            if (oc.deleted) {
              this.$store.dispatch("outgoCategories/delete", {
                vlf: this.$vlf("outgoCategories"),
                obj: oc
              });
            }
            this.$store.dispatch("outgoCategoryContactAssocs/delete", {
              vlf: this.$vlf("outgoCategoryContactAssocs"),
              obj: response.data.outgoCategoryContact
            });
          } else {
            this.$store.dispatch("outgoCategoryContactAssocs/update", {
              vlf: this.$vlf("outgoCategoryContactAssocs"),
              objs: [response.data.outgoCategoryContact]
            });
          }
        })
        .catch(error => console.log(error));
    },
    toggleOutgoCategoryDiary(oc) {
      this.$http
        .post("link/toggleOutgoCategoryDiary", {
          contactId: this.contact.idContactsContact,
          categoryId: oc.idWorldOutgoCategory
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store.dispatch("outgoCategoryContactAssocs/update", {
            vlf: this.$vlf("outgoCategoryContactAssocs"),
            objs: [response.data.outgoCategoryContact]
          });
        })
        .catch(error => {});
    },
    /* Nel caso l'utente non abbia già il customer come cliente del suo empl, creo anche l'associazione */
    addCustomerManager(userId) {
      this.$http
        .post("link/addCustomerManager", {
          contactId: this.contact.idContactsContact,
          userId
        }, {
          withCredentials: true
        })
        .then(response => {
          Promise.all(
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf('contacts'), objs: [response.data.contact]
            }),
            this.$store.dispatch("employments/update", {
              vlf: this.$vlf('employments'), objs: [response.data.employment]
            })
          );
        })
        .catch(error => {});
    },
    removeCustomerManager(userId) {
      this.$http
        .post("link/removeCustomerManager", {
          contactId: this.contact.idContactsContact,
          userId
        }, {
          withCredentials: true
        })
        .then(response => {
          Promise.all(
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf('contacts'), objs: [response.data.contact]
            }),
            this.$store.dispatch("employments/update", {
              vlf: this.$vlf('employments'), objs: [response.data.employment]
            })
          );
        })
        .catch(error => {});
    },
    createNewPricing() {
      /**
       * Se c'è più di un cliente per il progetto devo far scegliere all'utente quale utilizzare
       */
      this.$http
        .post("link/newPricing", {
          contactId: this.contact.idContactsContact
        }, {
          withCredentials: true
        })
        .then(response => {
          this.loadPage();
        })
        .catch(e => console.log(e));
    },
    loadData() {
      Promise.all([
        this.$store.dispatch("pricings/load", this.$vlf("pricings")),
        this.$store.dispatch("workCosts/load", this.$vlf("workCosts")),
        this.$store.dispatch(
          "outgoCategories/load",
          this.$vlf("outgoCategories")
        ),
        this.$store.dispatch(
          "outgoCategoryContactAssocs/load",
          this.$vlf("outgoCategoryContactAssocs")
        )
      ]).then(() => {
        this.$Progress.finish();
        this.loading = false;
      });
    },
    loadPage() {
      this.$http
        .get("link/pricing?idContact=" + this.contactId)
        .then(response => {
          Promise.all([
            this.$store.dispatch("pricings/update", {
              vlf: this.$vlf("pricings"),
              objs: [response.data.pricing]
            }),
            this.$store.dispatch("workCosts/update", {
              vlf: this.$vlf("workCosts"),
              objs: response.data.workCosts,
              cleanFilters: [o => o.contact === this.contactId]
            }),
            this.$store.dispatch("outgoCategories/update", {
              vlf: this.$vlf("outgoCategories"),
              objs: response.data.outgoCategories
            }),
            this.$store.dispatch("outgoCategoryContactAssocs/update", {
              vlf: this.$vlf("outgoCategoryContactAssocs"),
              objs: response.data.outgoCategoryContactAssocs
            }),
            this.$store.dispatch("bankAccounts/update", {
              vlf: this.$vlf("bankAccounts"),
              objs: response.data.bankAccounts
            }),
            this.$store.dispatch("workBankAccountAssocs/update", {
              vlf: this.$vlf("workBankAccountAssocs"),
              objs: response.data.workBankAccountAssocs
            })
          ]).then(() => {
            this.loading = false;
            this.$Progress.finish();
          });
        })
        .catch(error => {
          //Recupero dal db offline
        });
    }
  },
  created() {
    if(this.hasAccess && this.contact.workOwner == 474) {
      this.loading = true;
      this.loadData();
      this.loadPage();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
